import React from "react";
import { LockClosedIcon } from "@heroicons/react/24/outline"

const AccessDeniedPage = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "calc(100vh - 135px)",
      }}
    >
      <LockClosedIcon style={{
        width: "100px",
        height: "100px",
       }} />
      <h1><b>Access Denied</b></h1>
      <p
        style={{
          textAlign: "center",
          maxWidth: "400px",
          color: "#666",
          marginTop: "16px",
        }}
      >
        The Providers section is only available during your scheduled shift.
        Access will be enabled automatically when your shift begins.
      </p>
    </div>
  );
}

export default AccessDeniedPage;